import axios from "axios";
import { del, get, post, put, patch } from "./api_helper";
import * as url from "./url_helper";

const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404: message = "Sorry! the page you are looking for could not be found"; break;
          case 500: message = "Sorry! something went wrong, please contact our support team"; break;
          case 401: message = "Invalid credentials"; break;
          default: message = err[1]; break;
        }
      }
      throw message;
    });
};

const postJwtRegister = (url1, data) => {
  return axios
    .post(url1, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404: message = "Sorry! the page you are looking for could not be found"; break;
          case 500: message = "Sorry! something went wrong, please contact our support team"; break;
          case 401: message = "Invalid credentials"; break;
          default: message = err[1]; break;
        }
      }
      throw message;
    });
};

const postFakeLogin = data => {
  return axios
    .post(url.POST_FAKE_LOGIN, data)
    .then(response => {
      if (response.status >= 200 && response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404: message = "Sorry! the page you are looking for could not be found"; break;
          case 500: message = "Sorry! something went wrong, please contact our support team"; break;
          case 401: message = "Invalid credentials"; break;
          default: message = err[1]; break;
        }
      }
      throw message;
    });
};

const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);
const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);
const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// Dummy functions for store sagas compatibility
export const getEvents = () => get(url.GET_EVENTS);
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event);
export const updateEvent = event => put(url.UPDATE_EVENT, event);
export const deleteEvent = event => del(url.DELETE_EVENT, { headers: { event } });
export const getCategories = () => get(url.GET_CATEGORIES);
export const addNewUser = user => post(url.ADD_NEW_USER, user);
export const deletePopup = user => del(url.DELETE_ORDER, { headers: { user } });
export const deleteUser = user => del(url.DELETE_ORDER, { headers: { user } });
export const getPopup = user => get(`${url.GET_ORDERS}/${user}`);
export const getStatisticData = () => get(url.GET_STATISTICS_DATA);
export const updatePopup = user => put(url.UPDATE_ORDER, user);
export const updateUser = user => put(url.UPDATE_ORDER, user);
export const visitorData = () => get(url.GET_VISITOR_DATA);
export const walletBalanceData = () => get(url.GET_WALLET_DATA);
export const getChats = () => get(url.GET_CHATS);
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);
export const getCryptoProduct = () => get(url.GET_CRYPTO_PRODUCTS);
export const getInvoiceDetail = id => get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });
export const getInvoices = () => get(url.GET_INVOICES);
export const getProjects = () => get(url.GET_PROJECTS);
export const getProjectsDetails = id => get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });
export const getWallet = () => get(url.GET_WALLET);
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);
export const deleteProject = project => del(url.DELETE_PROJECT, { headers: { project } });
export const updateProject = project => put(url.UPDATE_PROJECT, project);
export const getGroups = () => get(url.GET_GROUPS);
export const getContacts = () => get(url.GET_CONTACTS);
export const getMessages = () => get(url.GET_MESSAGES);
export const getTasks = () => get(url.GET_TASKS);
export const getOrders = () => get(url.GET_ORDERS);
export const getCustomers = () => get(url.GET_CUSTOMERS);
export const getShops = () => get(url.GET_SHOPS);
export const getCartData = () => get(url.GET_CART_DATA);
export const getProductDetail = id => get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });
export const getProducts = () => get(url.GET_PRODUCTS);
export const getJobList = () => get(url.GET_JOB_LIST);
export const getApplyJob = () => get(url.GET_APPLY_JOB);
export const addNewJobList = job => post(url.ADD_NEW_JOB_LIST, job);
export const updateJobList = job => put(url.UPDATE_JOB_LIST, job);
export const deleteJobList = job => del(url.DELETE_JOB_LIST, { headers: { job } });
export const deleteApplyJob = data => del(url.DELETE_APPLY_JOB, { headers: { data } });
export const getUserProfile = () => get(url.GET_USER_PROFILE);
export const updateMail = mail => put(url.UPDATE_MAIL, mail);
export const selectFolders = () => get(url.SELECT_FOLDER);
export const addMessage = message => post(url.ADD_MESSAGE, message);
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);
export const getEarningData = month => get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });
export const topSellingData = month => get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });
export const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);
export const onLikeComment = (commentId, productId) => post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, { params: { commentId, productId } });
export const onLikeReply = (commentId, productId, replyId) => post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, { params: { commentId, productId, replyId } });
export const onAddReply = (commentId, productId, replyText) => post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, { params: { commentId, productId, replyText } });
export const onAddComment = (productId, commentText) => post(`${url.ON_ADD_COMMENT}/${productId}`, { params: { productId, commentText } });
export const getMailsList = () => get(url.GET_MAILS_LIST);
export const getSelectedMails = selectedmails => post(url.GET_SELECTED_MAILS, selectedmails);
export const setfolderonmails = (selectedmails, folderId, activeTab) => post(url.SET_FOLDER_SELECTED_MAILS, { selectedmails, folderId, activeTab });

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  postSocialLogin,
};
